export default {
  en: {
    PUBLISHERS_HEADER: 'Manage Publishers',
    PUBLISHERS_SEARCH_PH: 'Search Publisher',
    PUBLISHERS_ADD_BUTTON: 'Add Publisher',
    PUBLISHER_SHOW_ALL: 'Show All Publishers',
    PUBLISHERS_HEADER_NONE: 'You do not have any Publishers.',
    PUBLISHERS_NAME: 'Name',
    PUBLISHERS_ID: 'ID',
    PUBLISHERS_PERMISSIONS_NUMBER: 'Create Numbers',
    PUBLISHERS_CREATE_NUMBERS: 'Create Numbers',
    PUBLISHERS_CURRENT_DAY: 'Day',
    PUBLISHERS_CURRENT_HOUR: 'Hour',
    PUBLISHERS_CURRENT_LIVE: 'Live',
    PUBLISHERS_CURRENT_MONTH: 'Month',
    PUBLISHERS_STATUS: 'Status',
    PUBLISHERS_TOTAL: 'Total',
    PUBLISHERS_CREATE_NUMBERS_TT: 'Publisher can create their own numbers billed to your account.',
    REQUIRED_LABEL: 'Required',
    PUBLISHER_EDIT_SUCCESS: 'Publisher Updated',
    PUBLISHER_NOTICE_CREATE: 'Publisher Created',
    ACCOUNT_SETTING_TOGGLE_PUBLISHER_BLOCK_CALLS_ON_CAP_SETTING_DISABLED: 'Block',
    ACCOUNT_SETTING_TOGGLE_PUBLISHER_BLOCK_CALLS_ON_CAP_SETTING_ENABLED: 'Allow',
    PUBLISHER_COMPANY_DEFAULT: 'Ringba',
    PUBLISHER_COMPANY_TT: `Enter your Publisher's company name.`,
    PUBLISHER_COMPANY: 'Name',
    PUBLISHER_SUBID_DEFAULT: ' ',
    PUBLISHER_SUBID_TT: `Enter your Publisher's tracking subid.`,
    PUBLISHER_SUBID: 'Sub ID',
    PUBLISHER_NUMBER_CREATION_TT: 'When enabled your publisher can create their own numbers.',
    PUBLISHER_NUMBER_CREATION: 'Number Creation',
    ACCOUNT_SETTINGS_PUBLISHER_BLOCK_CALLS_ON_CAP: 'Block Calls After Payout Cap Is Reached',
    PUBLISHER_ACCEPT_CALLS_ON_CAP_TT: 'Enable or disable the ability to block calls after the payout caps for this publisher is reached. This will only use specific payout overrides for the publisher and ignore any campaign-level payout caps.',
    ACCOUNT_SETTING_TOGGLE_PUBLISHER_RECORDING_SETTING_DISABLED: 'Disabled',
    ACCOUNT_SETTING_TOGGLE_PUBLISHER_RECORDING_SETTING_ENABLED: 'Enabled',
    LABEL_OVERRIDE_TRUSTED_FORM: 'Trusted Form Settings',
    TOOLTIP_OVERRIDE_TRUSTED_FORM: 'Use the account settings, or override with custom Trusted Form settings.',
    PUBLISHER_ACCESS_TO_RECORDINGS: 'Access To Recordings',
    PUBLISHER_ACCESS_TO_RECORDINGS_TT: `Use Account Setting, Enable or Disable this publisher's ability to see recordings in the report.`,
    ACCOUNT_SETTING_TOGGLE_GLOBAL: 'Account Setting',
    INVALID_FORM: 'Please fill out required or invalid fields and try again',
    PUBLISHERS_ACTIONS_I_EDIT_ALT: 'Edit Publisher',
    MANAGE_USER_INVITES: 'Manage Invites',
    PUBLISHERS_ACTIONS_REPORTING: 'View Reports',
    PUBLISHERS_ACTIONS_PAUSE: 'Pause Publisher',
    DELETE_PUBLISHER_SUCCESSFUL_MESSAGE: 'Publisher Deleted',
    PUBLISHERS_ACTIONS_PAUSE: 'Pause Publisher',
    PUBLISHERS_ACTIONS_ENABLE: 'Enable Publisher',
    PUBLISHERS_ACTIONS_DELETE: 'Delete Publisher',
    PUBLISHERS_PAUSE_SUCCESSFUL: 'Publisher Paused',
    DELETE_AFFILIATE_MODAL_TITLE: 'Delete Publisher',
    DELETE_AFFILIATE_MODAL_CANCEL_ACTION: 'Cancel',
    DELETE_AFFILIATE_MODAL_CONFIRM_ACTION: 'Delete',
    DELETE_AFFILIATE_MODAL_NONE_ASSOCIATION_TEXT: 'The publisher, <strong>{publisherName}</strong>, is not associated with any campaign, number, number pool or user.',
    DELETE_AFFILIATE_MODAL_ASSOCIATION_TEXT: 'Are you sure you want to delete this publisher?</br></br><strong>{publisherName}</strong> is currently associated with the following items:',
    DELETE_AFFILIATE_MODAL_VIEW_NUMBER_POOL: 'View Number Pool',
    DELETE_AFFILIATE_MODAL_CHECK_ASSOCIATION_TEXT: `Determining if this publisher is currently associated with any <strong class='f-s-13'>Campaigns, Numbers, Number Pools or Users.</strong>`,
    DELETE_AFFILIATE_MODAL_CHECK_ASSOCIATION_ERROR_TEXT: 'An error occurred while determining associated Campaigns, Numbers, Number Pools or Users, please try again.',
    DELETE_AFFILIATE_KEEP_NUMBERS_TEXT: 'Keep Numbers',
    VIEW_CAMPAIGN: 'View Campaign',
    PAUSE_AFFILIATE_MODAL_TITLE: 'Pause Publisher',
    PAUSE_AFFILIATE_MODAL_CANCEL_ACTION: 'Cancel',
    PAUSE_AFFILIATE_MODAL_CONFIRM_ACTION: 'Pause',
    PAUSE_AFFILIATE_MODAL_TEXT: 'Are you sure you want to pause <strong>{affiliateName}</strong>?',
    PUBLISHERS_HEADER_LOADING: 'Loading Publishers',
    REFERENCES_LOADING: 'Loading References',
    REFERENCES_EMPTY: 'This publisher does not have any references.',
  }
};
